<template>
  <div
    class="navbar-user-dropdown"
    :class="[
      { 'dropdown-open': navbarDropdown === true }, 
      'dropdown-' + navbarGetLevelColor,
      'dropdown-' + authUser.user.rank
    ]"
  >
    <button v-on:click="navbarSetDropdown(!navbarDropdown)" class="button-toggle">
      <div class="button-avatar">
        
        <!-- Sadece VIP badge gösteriliyor -->
        <img
          v-if="vipBadgeImage"
          :src="vipBadgeImage"
          class="vip-badge-only"
          alt="VIP"
        />
      </div>
      <div class="button-info">
        <div class="info-username">
          <span v-html="authUser.user.username"></span>
          <IconDropdown />
        </div>
        <div class="info-level">
          <div class="info-progress-bar-with-label" v-if="nextVipLevel && nextVipLevel.requiredXp">
            <div class="bar-outer">
              <div
                class="bar-inner"
                :style="{ width: vipProgress + '%' }"
              ></div>
            </div>
         
          </div>
        </div>
      </div>
    </button>

    <div
      class="dropdown-menu"
      v-bind:class="{ 'menu-admin': authUser.user.rank === 'admin' }"
    >
      <div class="menu-inner">
        <div class="dropdown-user-info" v-if="vipLevel">
          <div class="vip-avatar-box">
             <img 
          v-if="authUser?.user?.avatar" 
          :src="authUser.user.avatar" 
          alt="Avatar" 
          class="avatar-image"
        />
            <img
              v-if="vipBadgeImage"
              :src="vipBadgeImage"
              class="vip-badge"
              alt="VIP"
            />
          </div>
          <div class="vip-level-label">
            <span>{{ vipLevel.levelName }}</span>
            <img
              v-if="vipBadgeImage"
              :src="vipBadgeImage"
              class="vip-badge-small"
            />
          </div>
          <div class="vip-progress-wrap">
            <div class="vip-progress-labels">
              <span>VIP {{ vipLevel.level }}</span>
              <span v-if="nextVipLevel">VIP {{ nextVipLevel.level }}</span>
            </div>
            <div class="vip-progress-bar">
              <div class="bar-fill" :style="{ width: vipProgress + '%' }">
                <span class="bar-percent">{{ vipProgress }}%</span>
              </div>
            </div>
            
          </div>
        </div>

        <router-link v-on:click.native="navbarSetDropdown(false)" to="/profile">
          <IconUser />
          {{ $t('navbar.7') }}
        </router-link>
        <button v-on:click="navbarVaultButton()">
          <IconVault />
          {{ $t('navbar.8') }}
        </button>
        <router-link v-on:click.native="navbarSetDropdown(false)" to="/rewards">
          <IconRakeback />
          {{ $t('navbar.9') }}
        </router-link>
        <router-link v-on:click.native="navbarSetDropdown(false)" to="/affiliates">
          <IconAffiliates />
          {{ $t('navbar.10') }}
        </router-link>
        <router-link v-on:click.native="navbarSetDropdown(false)" to="/leaderboard">
          <IconLeaderboard />
          {{ $t('navbar.11') }}
        </router-link>
        <router-link
          v-if="authUser.user.rank === 'admin'"
          v-on:click.native="navbarSetDropdown(false)"
          to="/admin"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path
              d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
            />
          </svg>
          ADMIN
        </router-link>
        <button v-on:click="navbarLogoutButton()">
          <IconSignOut />
          {{ $t('navbar.12') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import IconDropdown from '@/components/icons/IconDropdown';
import IconUser from '@/components/icons/IconUser';
import IconVault from '@/components/icons/IconVault';
import IconRakeback from '@/components/icons/IconRakeback';
import IconAffiliates from '@/components/icons/IconAffiliates';
import IconLeaderboard from '@/components/icons/IconLeaderboard';
import IconSignOut from '@/components/icons/IconSignOut';

export default {
  name: 'NavbarUserDropdown',
  components: {
    IconDropdown,
    IconUser,
    IconVault,
    IconRakeback,
    IconAffiliates,
    IconLeaderboard,
    IconSignOut
  },
  data() {
    return {
      navbarDropdown: false
    }
  },
  methods: {
    ...mapActions('vip', ['fetchUserVip']),
    ...mapActions([
      'modalsSetShow', 
      'authLogoutUser'
    ]),
    navbarSetDropdown(value) {
      this.navbarDropdown = value;
    },
    navbarVaultButton() {
      this.modalsSetShow('Vault');
      this.navbarSetDropdown(false);
    },
    navbarLogoutButton() {
      this.navbarSetDropdown(false);
      this.authLogoutUser();
    }
  },
  computed: {
    ...mapGetters(['authUser']),
    ...mapGetters('vip', [
      'vipLevel',
      'userXp',
      'nextVipLevel',
      'vipProgress',
      'vipDisplayXp',
      'vipNextXp'
    ]),

    vipBadgeImage() {
      return this.vipLevel?.vipBadgeImage
        ? process.env.VUE_APP_BACKEND_URL + this.vipLevel.vipBadgeImage
        : null;
    },

    navbarGetLevel() {
      let level = Math.floor(Math.pow(this.authUser.user.xp, 1 / 3));
      return level >= 100 ? 100 : level;
    },
    navbarGetLevelColor() {
      let color = '';
      if(this.navbarGetLevel >= 2 && this.navbarGetLevel < 26) { color = 'blue'; }
      else if(this.navbarGetLevel >= 26 && this.navbarGetLevel < 51) { color = 'green'; }
      else if(this.navbarGetLevel >= 51 && this.navbarGetLevel < 76) { color = 'orange'; }
      else if(this.navbarGetLevel >= 76 && this.navbarGetLevel < 100) { color = 'red'; }
      else if(this.navbarGetLevel >= 100) { color = 'purple'; }
      return color;
    }
  },
  created() {
    this.fetchUserVip();

    document.addEventListener('click', (event) => {
      if(!this.$el.contains(event.target) && this.navbarDropdown === true) {
        this.navbarSetDropdown(false);
      }
    });
  }
}
</script>


<style scoped>
    .navbar-user-dropdown {
        position: relative;
    }

    .navbar-user-dropdown button.button-toggle {
        display: flex;
    align-items: center;
    background: var(--background1);
    border-radius: 10px;
    padding-left: 10px; 
    padding-right: 10px;
    padding-top: 2px;
    padding-bottom: 2px;
    height: 40px;
    position: relative;
    z-index: 1;
    }



    .navbar-user-dropdown .button-avatar {
        width: 35px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-right: 10px;
        border-radius: 50%;
        
        overflow: hidden;
    }

   

    .navbar-user-dropdown .button-avatar .avatar-image {
        width: 100%;
        height: 100%;
    }

    .navbar-user-dropdown .button-info {

    }

    .navbar-user-dropdown .info-username {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 700;
        color: #ffffff;
    }

    .navbar-user-dropdown .info-username span {
       
        max-width: 80px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .vip-badge-on-avatar {
  position: absolute;
  bottom: -4px;
      left: 25px;
  width: 20px;
  height: 20px;
  object-fit: contain;
  border-radius: 50%;
 
}

.info-progress-bar {
  width: 100%;
  
}

.bar-outer {
  width: 60px;
  height: 7px;
  background: var(--bar-outer);
  border-radius: 5px;
  overflow: hidden;
}

.bar-inner {
  height: 100%;
  background: var(--bar-inner);
  transition: width 0.3s ease;
}

.dropdown-user-info {
  width: 100%;
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.vip-avatar-box {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
}

.vip-avatar-box .avatar-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.vip-avatar-box .vip-badge {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  object-fit: contain;
  background: #000;
  border: 1px solid #01e0a3;
}

.vip-level-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  color: #ffffff;
  margin-bottom: 6px;
  font-family: var(--font-header);
      font-weight: 600;
}

.vip-level-label img.vip-badge-small {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.vip-progress-wrap {
  width: 100%;
}

.vip-progress-labels {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #bbbfd0;
  margin-bottom: 2px;
  padding: 0 3px;
}

.vip-progress-bar {
  position: relative;
  background: var(--bar-outer);
  height: 6px;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
}

.bar-fill {
  height: 100%;
  background: var(--bar-inner);
  position: relative;
  transition: width 0.3s ease;
}

.bar-percent {
  position: absolute;
  right: 4px;
  top: -14px;
  font-size: 10px;
  color: #ffffff;
}

    .navbar-user-dropdown .info-username svg {
        width: 10px;
        margin-left: 12px;
        fill: #ffffff;
        transition: all 0.3s ease;
    }

    .navbar-user-dropdown.dropdown-open .info-username svg {
         transform: rotate(180deg);
    }

    .navbar-user-dropdown .info-level {
        height: 17px;
        margin-top: 2px;
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 700;
        color: #9e9e9e;
    }

    .navbar-user-dropdown.dropdown-blue .info-level {
        color: #559ee4;
    }

    .navbar-user-dropdown.dropdown-green .info-level {
        color: #b8e92d;
    }

    .navbar-user-dropdown.dropdown-orange .info-level {
        color: #fca311;
    }

    .navbar-user-dropdown.dropdown-red .info-level {
        color: #ff4e4e;
    }

    .navbar-user-dropdown.dropdown-purple .info-level {
        color: #6953f1;
    }

    .navbar-user-dropdown.dropdown-partner .info-level {
        color: #eca822;
    }

    .navbar-user-dropdown.dropdown-mod .info-level {
        color: #ffb703;
    }

    .navbar-user-dropdown.dropdown-admin .info-level {
        color: var(--leveltext);
    }

    .navbar-user-dropdown .rank-box {
        width: 22px;
        height: 16px;
        position: relative;
        margin-left: 6px;
        padding: 1px;
    }

    .navbar-user-dropdown .rank-box svg {
        width: 8px;
    }

    .navbar-user-dropdown .rank-box::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(180deg, rgba(6, 36, 61, 0) 0%, #ffb703 100%);
        clip-path: polygon(3px 0, calc(100% - 3px) 0, 100% 25%, 100% 75%, calc(100% - 3px) 100%, 3px 100%, 0 75%, 0 25%);
        z-index: -1;
    }

    .navbar-user-dropdown .rank-box .box-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #112531;
        clip-path: polygon(3px 0, calc(100% - 3px) 0, 100% 25%, 100% 75%, calc(100% - 3px) 100%, 3px 100%, 0 75%, 0 25%);
    }

    .navbar-user-dropdown .dropdown-menu {
        height: 0;
        width: 230px;
        position: absolute;
        top: 50px;
         
        right: -10px;
        padding: 0 10px;
        transition: height 0.2s ease;
        overflow: hidden;
        z-index: 1;
    }


    .navbar-user-dropdown .info-level {
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
  margin-left: 4px;
}

    .navbar-user-dropdown.dropdown-open .dropdown-menu {
       height: 100vh;
       padding: 0 10px 10px 10px;
    }

    .navbar-user-dropdown.dropdown-open .dropdown-menu.menu-admin {
         height: 100vh;
        
    }

    .navbar-user-dropdown .menu-inner {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
       
        border-radius: 12px;
        background: var(--dropdownbg);
       
        z-index: 1;
    }

     

    .navbar-user-dropdown .menu-inner button,
    .navbar-user-dropdown .menu-inner a {
        width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        padding: 0 15px;
        font-size: 12px;
        font-weight: 600;
        color: #bbbfd0;
        
        transition: color 0.3s ease;
    }

    .navbar-user-dropdown .menu-inner button:first-child,
    .navbar-user-dropdown .menu-inner a:first-child {
        border-radius: 10px 0 0 0;
    }

    .navbar-user-dropdown .menu-inner button:last-child,
    .navbar-user-dropdown .menu-inner a:last-child {
        border-radius: 0 0 10px 10px;
        border-bottom: none;
    }

    .navbar-user-dropdown .menu-inner button:hover,
    .navbar-user-dropdown .menu-inner a:hover {
        color: #ffffff;
    }

     .navbar-user-dropdown .menu-inner button svg,
     .navbar-user-dropdown .menu-inner a svg {
         width: 13px;
         margin-right: 8px;
         fill: #bbbfd0;
     }

     @media only screen and (max-width: 1175px) {
    .navbar-user-dropdown .button-info {
        display: none; /* Username ve level tamamen gizlenir */
    }

    .navbar-user-dropdown .button-avatar {
        margin-right: 0; /* Avatar sola yaslanır */
    }

    .navbar-user-dropdown.dropdown-open .dropdown-menu.menu-admin {
      
    }
    .navbar-user-dropdown.dropdown-open .dropdown-menu {
       height: 100vh;
       padding: 0 10px 10px 10px;
      width: 230px;
        margin-left: -111px;
    }
}

.vip-badge-only {
  width: 100%;     /* avatar ile aynı boyut */
  height: 100%;
 
   
  display: block;
}
</style>
